import React from 'react';

function Hero({ heading, subheading, des, img }) {
  return (
    <div
      className="hero-section position-relative d-flex align-items-center"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.7), rgba(0,0,0,0.3)), url(${img})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '85vh',
        marginTop: '66px',
        color: '#fff',
      }}
    >
      <div className="container position-relative z-2">
        <div className="row">
          <div className="col-12 col-md-10 col-lg-8">
            <h3 className="text-uppercase text-primary mb-2" style={{ textShadow: '1px 1px 4px rgba(0,0,0,0.6)' }}>
              {heading}
            </h3>
            <h2 className="text-warning fw-bold mb-3" style={{ textShadow: '2px 2px 6px rgba(0,0,0,0.7)' }}>
              {subheading}
            </h2>
            <p
              className="lead text-light"
              style={{
                lineHeight: '1.6',
                textShadow: '1px 1px 4px rgba(0,0,0,0.6)',
                fontSize: '1.1rem',
              }}
            >
              {des}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
